export default class ForbiddenError extends Error {
  constructor(message, status = 403) {
    super(message);
    this.name = 'ForbiddenError';
  }
}
